import { all } from 'redux-saga/effects';
import emailDesignerSaga from './designer-sagas';
import notificationListSaga from './notification-list-sagas';
import templatePickerSaga from './template-picker-sagas';

export default function* rootSaga() {
  yield all([emailDesignerSaga(), notificationListSaga(), templatePickerSaga()]);
}
